<template>
    <div>

        <div class="row">
            <div class="col">
                <div class="sau-bx bx-pad">
                    <div class="row">
                        <div class="col text-center">
                        <h4>Console Access</h4>
                            <p>Open the Console to start a remote session</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">

                            <sau-loading v-if="!ready">
                                <template slot="message">Fetching Access Details</template>
                            </sau-loading>

                            <div class="row" v-if="ready && retrieved">
                                <div class="col-6">
                                    <login-details-template :username="accessUsername" :password="accessPassword" :port="accessPort" />
                                </div>
                            </div>

                            <div class="row" v-if="ready && !retrieved">
                                <div class="col">
                                    <sau-apiro-response type="error" support="true">
                                        <template slot="message">There was an issue retrieving your login details.</template>
                                        <template slot="details">
                                            <p>For more information please contact our Support Team.</p>
                                        </template>
                                    </sau-apiro-response>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="row pt-3">
                        <div class="col mx-auto text-center">
                            <!-- only display console link if logins were also retrieved -->
                            <a v-if="ready && retrieved" :href="consoleLink" target="_blank" class="btn btn-success text-center">Open Console</a>
                            <p class="text-center mt-2 text-sm">If you are having trouble accessing the console, please ensure you have disabled any adblockers.</p>
                        </div>
                    </div>

                </div>
            </div>
        </div>

    </div>
</template>

<script>
import LoginDetailsTemplate from '../templates/LoginDetails';
export default {
    components: {
        'login-details-template': LoginDetailsTemplate,
    },
    data() {
        return {
            showAccessPassword: false,
            retrieved: false,
            accessPassword: '',
            accessUsername: '',
            accessPort: null,
            ready: false,
        }
    },
    created() {
        this.startApp();
    },
    computed: {
        consoleLink() {
            return '/service/' + this.getServiceType() + '/' + this.getServiceId() + '/console';
        }
    },
    methods:{
        startApp() {
            this.vuexLoading().then(response => {

                let accessPromise = this.getAccessDetails().then(response => {
                    if(response.data) {
                        // We don't actually need to set these right now.. We just wanted to know we *could* fetch them..
                        //this.token = response.data['console-token'];
                        //this.hostname = response.data.hostname;
                    }
                });

                let loginPromise = this.getLoginDetails().then(response => {
                    if(response.data) {
                        this.accessUsername = response.data.username;
                        this.accessPassword = response.data.password;
                        // Default username for RPD is administrator, RDP uses different port
                        this.accessPort = this.accessUsername.toLowerCase() === 'administrator' ? 3389 : 2929;
                        this.retrieved = true;
                    }
                });

                Promise.all([loginPromise, accessPromise]).then(() => this.ready = true);

            });
        }
    }
}
</script>

<style>
.space {
    margin:0px 2px;
}
.control-panel-form input[type="submit"] {
    cursor: pointer !important;
    background: #00ce7d !important;
    color:#fff !important;
    padding: 8px 15px 8px 15px !important;
    border: 1px solid #00ce7d !important;
}
</style>
